import defaultConfig from '@basecom-gmbh/pond/formkit.config';
import { rootClasses } from './formkit.theme.js';
import { createAutoAnimatePlugin } from '@formkit/addons';
import { de } from '@formkit/i18n';

defaultConfig.config.rootClasses = rootClasses;

function scrollToErrors(node) {
    if (node.props.type === 'form') {
        function scrollTo(node) {
            const el = document.getElementById(node.props.id);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
            }
        }

        function scrollToErrors() {
            node.walk(child => {
                // Check if this child has errors
                if (child.ledger.value('blocking') || child.ledger.value('errors')) {
                    // We found an input with validation errors
                    scrollTo(child);
                    // Stop searching
                    return false;
                }
            }, true);
        }

        const onSubmitInvalid = node.props.onSubmitInvalid;
        node.props.onSubmitInvalid = () => {
            onSubmitInvalid(node);
            scrollToErrors();
        };
        node.on('unsettled:errors', scrollToErrors);
    }
    return false;
}

const defaultPlugins = {
    autoAnimate: createAutoAnimatePlugin(
        {
            duration: 250,
            easing: 'ease-in-out',
        },
        {
            global: ['outer', 'inner'],
            form: ['form'],
            repeater: ['items'],
        },
    ),
    scrollToErrors,
};

const iconsConfig = import.meta.glob('assets/icons/**.svg', {
    query: '?raw',
    import: 'default',
    eager: true,
});

const icons = Object.keys(iconsConfig).reduce((acc, key) => {
    const iconName = key.replace('/assets/icons/', '').replace('.svg', '');

    acc[iconName] = iconsConfig[key];

    return acc;
}, {} as Record<string, unknown>);

export default {
    icons,
    iconLoader: (iconName: string) =>
        // returns the icon from fontawesome as fallback (or undefined if not found)
        fetch(`https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free/svgs/solid/${iconName}.svg`)
            .then(async r => {
                const icon = await r.text();
                if (icon.startsWith('<svg')) {
                    // returns the icon from fontawesome
                    return icon;
                }
                // returns undefined if the icon is not found in either the local repository or the CDN
                return undefined;
            })
            .catch(e => {
                console.error(e);
                return undefined;
            })
    ,
    locales: { de },
    config: {
        rootClasses,
    },
    plugins: Object.values(defaultPlugins),
    props: {
        decoratorIcon: 'check',
    },
};
